module.exports = __webpack_public_path__ + "img/rstep3z.12f551b8.png";